module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel-cell"
  }, [_c('router-link', {
    attrs: {
      "to": '/movie-detail/' + _vm.movie.id
    }
  }, [_c('div', {
    staticClass: "thumbnail-wrapper",
    attrs: {
      "id": 'i_3_' + _vm.index
    }
  }, [_c('div', {
    staticClass: "thumbnail",
    style: ({
      backgroundImage: 'url(' + _vm.movie.imageUrl + ')'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "carousel-title",
    domProps: {
      "innerHTML": _vm._s(_vm.movie.shortTitle)
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78c1a060","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MovieTeaserDefault.vue
// module id = 89
// module chunks = 0